var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('b-row',[(_vm.arch.length > 0)?_c('b-col',{attrs:{"col":"","cols":"12"}},[_c('tabs',{attrs:{"tabs":_vm.arch,"title":_vm.$t('tables.archetype')}})],1):_vm._e(),(
      _vm.arch.length === 0 &&
        _vm.actions.length === 0 &&
        _vm.wellbeing.labels &&
        _vm.wellbeing.labels.length === 0
    )?_c('b-col',[_c('empty-card',{attrs:{"type":"user.wellbeing"}})],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }